<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#f2f2f2">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_obra.new ? "Cadastrar obra" : get_obra.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Gerencie os detalhes abaixo
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </transition>
      </div>
    </v-flex>

    <div
      style="min-height: 80vh; max-height: 80vh;"
      class="windows-style-content expande-horizontal wrap"
    >
      <v-tabs
        v-model="tabs"
        :background-color="$theme.primary"
        dark
        class="fonte"
      >
        <v-tab>Informações</v-tab>
        <v-tab :disabled="!get_obra._id" @click="listWorkSales">Vendas da obra</v-tab>
      </v-tabs>

      <v-flex v-if="tabs === 0" xs12>
        <v-form ref="form">
          <div class="expande-horizontal wrap pt-4">
            <v-flex class="px-3" xs12 md6>
              <v-text-field
                v-model="get_obra.nome"
                dense
                outlined
                clearable
                :color="$theme.primary"
                :rules="[v => !!v || 'Preencha este campo']"
                label="Nome da obra"
                placeholder="ex: Hospital"
              />
            </v-flex>

            <v-flex class="px-3" xs12 md6>
              <v-autocomplete
                v-model="get_obra.unity"
                dense
                outlined
                clearable
                return-object
                item-text="nome"
                :items="get_unidades.docs"
                :color="$theme.primary"
                label="Polo"
              />
            </v-flex>

            <v-flex class="px-3" xs12 md6>
              <v-autocomplete
                v-model="get_obra.responsavel"
                dense
                outlined
                clearable
                return-object
                item-text="nome"
                :items="get_funcionarios.docs"
                :color="$theme.primary"
                :rules="responsibleRules"
                label="Responsável interno"
              />
            </v-flex>

            <v-flex class="px-3" xs12 md6>
              <v-combobox
                v-model="get_obra.comodos"
                dense
                outlined
                chips
                multiple
                clearable
                deletable-chips
                clear-icon="mdi-close-circle"
                hint="Pressione enter para adicionar um novo"
                :color="$theme.primary"
                label="Cômodos"
              />
            </v-flex>
          </div>

          <v-divider class="mx-3 my-2" />

          <div class="expande-horizontal wrap">
            <v-flex class="px-3" xs12 md6>
              <v-text-field
                v-model="get_obra.contato_obra.nome"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Contato da obra"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md6>
              <v-text-field
                v-model="get_obra.contato_obra.telefone"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Telefone do contato"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md6>
              <v-text-field
                v-model="get_obra.engenheiro.nome"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Engenheiro"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md6>
              <v-text-field
                v-model="get_obra.engenheiro.telefone"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Telefone do engenheiro"
              />
            </v-flex>
          </div>

          <v-divider class="mx-3 my-2" />

          <div class="expande-horizontal wrap">
            <v-flex class="px-3" xs12 md8>
              <v-text-field
                v-model="get_obra.address.formatted_address"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Endereço"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md4>
              <v-text-field
                v-model="get_obra.address.number"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Número"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md4>
              <v-text-field
                v-model="get_obra.address.neighborhood"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Bairro"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md4>
              <v-text-field
                v-model="get_obra.address.city"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Cidade"
              />
            </v-flex>
            <v-flex class="px-3" xs12 md4>
              <v-text-field
                v-model="get_obra.address.state"
                dense
                outlined
                clearable
                :color="$theme.primary"
                label="Estado"
              />
            </v-flex>
          </div>

          <v-flex class="px-3" xs12>
            <v-textarea
              v-model="get_obra.informacoes"
              dense
              outlined
              clearable
              rows="3"
              :color="$theme.primary"
              label="Observações"
            />
          </v-flex>
        </v-form>
      </v-flex>

      <v-flex v-if="tabs === 1" xs12>
        <div class="expande-horizontal wrap pa-3">
          <div class="sales-heading">
            <strong>{{ sales.length }} venda{{ sales.length === 1 ? "" : "s" }} vinculada{{ sales.length === 1 ? "" : "s" }}</strong>
            <span v-if="workHasOngoingSale && !get_obra.responsavel">
              Defina um responsável para manter esta obra em andamento.
            </span>
          </div>

          <div
            style="min-height: 64vh; max-height: 64vh; overflow: auto;"
            class="expande-horizontal wrap"
            v-if="sales.length > 0"
          >
            <v-flex xs12 md4 lg3 class="pa-2" v-for="sale in sales" :key="sale._id">
              <SaleItem :kanban="sale" />
            </v-flex>
          </div>

          <div class="expande-horizontal centraliza" v-else>
            <span class="my-12 fonte">Esta obra ainda não possui vendas vinculadas.</span>
          </div>
        </div>
      </v-flex>
    </div>

    <div class="expande-horizontal py-1 windows-style-bottom">
      <v-btn large dark @click="valida_form" :color="$theme.primary">
        <span class="fonte">Salvar</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import SaleItem from "@/apps/GestorDePedido/components/SaleItem.vue";
import { mapActions, mapGetters } from "vuex";

function ensureNested(obra) {
  if (!obra.comodos) obra.comodos = [];
  if (!obra.contato_obra) obra.contato_obra = {};
  if (!obra.engenheiro) obra.engenheiro = {};
  if (!obra.address) obra.address = {};
}

function normalizeText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export default {
  components: {
    SaleItem
  },
  computed: {
    ...mapGetters([
      "get_obra",
      "getLoggedUser",
      "get_funcionarios",
      "get_unidades"
    ]),
    responsibleRules() {
      return [
        value => !this.workHasOngoingSale || !!(value && (value._id || value.id || value)) || "Obra em andamento exige responsável"
      ];
    },
    workHasOngoingSale() {
      return this.sales.some(sale => this.isOngoingStatus(sale.status_do_pedido));
    }
  },
  data() {
    return {
      tabs: 0,
      sales: []
    };
  },
  methods: {
    ...mapActions([
      "criar_obra",
      "atualizar_obra",
      "fecha_modal_view_obra",
      "enableLoading",
      "disableLoading",
      "listar_funcionarios",
      "listar_unidades",
      "createGlobalMessage"
    ]),
    isOngoingStatus(status) {
      const normalized = normalizeText(status);
      if (!normalized) return false;
      if (["salvo", "orcamento", "orcamento salvo", "arquivado", "arquivada", "recusado", "recusada", "reprovado", "reprovada", "cancelado", "cancelada", "concluido", "finalizado", "entregue"].includes(normalized)) {
        return false;
      }
      return normalized.includes("producao")
        || normalized.includes("andamento")
        || normalized.includes("preparo")
        || normalized.includes("acabamento")
        || normalized.includes("pronto")
        || normalized.includes("entrega")
        || normalized.includes("despachado");
    },
    prepareObra() {
      ensureNested(this.get_obra);
    },
    loadReferences() {
      if (!this.get_funcionarios.docs || !this.get_funcionarios.docs.length) {
        this.listar_funcionarios();
      }
      if (!this.get_unidades.docs || !this.get_unidades.docs.length) {
        this.listar_unidades();
      }
    },
    listWorkSales() {
      if (!this.get_obra._id) {
        this.sales = [];
        return;
      }
      this.enableLoading();
      this.$run("obras/list-work-sales", {
        _id: this.get_obra._id
      }).then(res => {
        this.disableLoading();
        this.sales = res.data.docs || res.data || [];
      }).catch(error => {
        this.disableLoading();
        this.createGlobalMessage({
          type: "error",
          message: error.response?.data?.message || "Não foi possível listar as vendas da obra.",
          timeout: 5000
        });
      });
    },
    valida_form() {
      this.prepareObra();
      if (this.workHasOngoingSale && !this.get_obra.responsavel) {
        this.createGlobalMessage({
          type: "error",
          message: "Obra com venda em andamento exige responsável.",
          timeout: 5000
        });
        return;
      }
      if (this.$refs.form.validate()) {
        this.get_obra._id ? this.atualizar_obra() : this.criar_obra();
      }
    },
    backToList() {
      this.$store.commit("set_obra", {});
      this.$forceUpdate();
    }
  },
  created() {
    this.prepareObra();
    this.loadReferences();
    if (this.get_obra._id) {
      this.listWorkSales();
    }
  },
  watch: {
    "get_obra._id"() {
      this.prepareObra();
      this.sales = [];
      if (this.get_obra._id) {
        this.listWorkSales();
      }
    }
  }
};
</script>

<style scoped>
.sales-heading {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 10px;
  width: 100%;
}
.sales-heading span {
  color: #d97706;
  font-size: 12px;
}
</style>
